import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
// import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {

	async triggerPersistentButton(path, label, sameWindow) {
		Store.emit('PLAY_SOUND', 'count-down');
		return super.triggerPersistentButton(path, label, sameWindow);
	}

	triggerActionButton(homeEntVisible) {
		let actionData = this.getCurrentActionBtnAction(homeEntVisible);
		if (actionData?.icon === 'close') {
			Store.emit('PLAY_SOUND', 'mario-jump');
		}
		return super.triggerActionButton(homeEntVisible);
	}

	triggerBurgerBtn() {
		let actionData = this.getCurrentHeaderAction();
		if (actionData?.icon === 'burger') {
			Store.emit('PLAY_SOUND', 'flower-power');
		}

		return super.triggerBurgerBtn();
	}

}
